
  (function () {
    function patchMiniCart() {
      try {
        var MiniCartClass = customElements.get('mini-cart');
        if (MiniCartClass && MiniCartClass.prototype && !MiniCartClass.prototype.refreshCart) {
          MiniCartClass.prototype.refreshCart = async function () {
            try {
              var sectionsToRender = this.getSectionsToRender ? this.getSectionsToRender() : [];
              var sectionNames = sectionsToRender.map(function (s) { return s.section || s.id; }).filter(Boolean);
              var sectionsParam = sectionNames.length ? sectionNames.join(',') : 'mini-cart';

              var res = await fetch('/?sections=' + sectionsParam);
              if (!res.ok) throw new Error('Fetch sections failed: ' + res.status);
              var htmlMap = await res.json();

              sectionsToRender.forEach(function (s) {
                if (s.section && htmlMap[s.section] && !htmlMap[s.id]) {
                  htmlMap[s.id] = htmlMap[s.section];
                }
              });

              // 1. Cập nhật DOM của cart drawer
              this.renderContents({ sections: htmlMap });

              // 2. Chờ DOM ổn định rồi vẽ lại widget chuẩn vị trí
              setTimeout(function () {
                try {
                  if (window.tlCartGoalEmbed && typeof window.tlCartGoalEmbed.renderAllCartGoals === 'function') {
                    // Dọn dẹp duplicate nếu có trước khi render để chống giật
                    var existingWidgets = document.querySelectorAll('.tl__cart-goal__container__drawer');
                    if (existingWidgets.length > 1) {
                      for (var i = 1; i < existingWidgets.length; i++) {
                        existingWidgets[i].remove();
                      }
                    }
                    window.tlCartGoalEmbed.renderAllCartGoals();
                  }

                  if (window.tlGiftInCartWidget && typeof window.tlGiftInCartWidget.updateAllOfferCardsUI === 'function') {
                    window.tlGiftInCartWidget.updateAllOfferCardsUI();
                  }
                } catch (widgetErr) {
                  console.error('[Salepify] Error re-rendering widgets:', widgetErr);
                }
              }, 250);

            } catch (err) {
              console.error('[Salepify] Error in custom refreshCart:', err);
              // Fallback an toàn nếu fetch thất bại
              window.location.reload();
            }
          };
          return true;
        }
      } catch (e) {
        console.error('[Salepify] Error patching mini-cart:', e);
      }
      return false;
    }

    if (!patchMiniCart()) {
      customElements.whenDefined('mini-cart').then(patchMiniCart);
    }
  })();
